var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LuuLayout",
    {
      scopedSlots: _vm._u([
        {
          key: "logo",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticStyle: { "font-size": "20px", display: "inline-block" },
                },
                [
                  _c("img", {
                    staticStyle: { width: "100px" },
                    attrs: { src: require("../assets/logo.svg"), alt: "" },
                  }),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "l-right" },
                [
                  _c("LocalesSwitcher", {
                    staticClass: "layout__locales",
                    attrs: { white: "" },
                  }),
                  _c("LuuUserControl", {
                    staticClass: "layout__user-control",
                    attrs: {
                      name: _vm.user.name,
                      email: _vm.user.email,
                      avatar: _vm.user.avatar,
                      menus: _vm.userControlMenu,
                    },
                  }),
                  _c(
                    "a",
                    { attrs: { href: "/account", target: "_blank" } },
                    [
                      _c("LuuUserAvatar", {
                        staticClass: "layout__avatar--mobile",
                        attrs: { url: _vm.user.avatar, name: _vm.user.name },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "switch__wrapper",
                  on: {
                    click: function ($event) {
                      _vm.mobileMenuShowing = true
                    },
                  },
                },
                [_c("i", { staticClass: "iconfont iconbianzu5" })]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "aside",
          fn: function () {
            return [
              _c(
                "LuuMenu",
                { attrs: { "is-route": "" } },
                _vm._l(_vm.bindMenus, function (item) {
                  return _c("LuuMenuItem", {
                    key: item.id,
                    staticClass: "layout__menu-item",
                    attrs: {
                      label: item.label,
                      "icon-class": item.iconClass,
                      active: _vm.selected === item.path,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleSelectMenu(item)
                      },
                    },
                  })
                }),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("AppMain"),
      _c("ChangePasswordModal", {
        attrs: { visible: _vm.changePasswordVisible },
        on: {
          "update:visible": function ($event) {
            _vm.changePasswordVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }